import { render, staticRenderFns } from "./AdminProductionTypes.vue?vue&type=template&id=92c9cf0c"
import script from "./AdminProductionTypes.vue?vue&type=script&lang=js"
export * from "./AdminProductionTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92c9cf0c')) {
      api.createRecord('92c9cf0c', component.options)
    } else {
      api.reload('92c9cf0c', component.options)
    }
    module.hot.accept("./AdminProductionTypes.vue?vue&type=template&id=92c9cf0c", function () {
      api.rerender('92c9cf0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminProductionTypes.vue"
export default component.exports